import { useNavigate, useSearchParams } from "react-router-dom";

import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import Loader from "../../components/common/Loader/Loader";
import closeIcon from "../../assets/images/close.svg";
import {
  CreateOrUpdatePlan,
  sendToken,
  verifytoken,
} from "../../api/SbDriveServices";
import useLanguageTranslate from "../../hooks/useLanguageTranslate";
import { selectProfileData } from "../../redux/features/profileSlice";
import RenewMotorLayout from "../motorInsurancePages/renewalMotorPolicy/renewMotorLayout";

const UserNotDriverForm = ({ formData, handleChange, translate, errors }) => {
  return (
    <div className="max-w-lg mx-auto space-y-6 bg-white pt-4">
      {/* Name Fields */}
      <div>
        <label className="block text-sm text-gray-500 mb-1 text-left">
          {translate("CPR", "رقم الهوية CPR")}
        </label>
        <input
          type="number"
          placeholder=""
          name="CPR"
          value={formData.CPR}
          onChange={handleChange}
          className={`w-full border rounded-md px-3 py-2 focus:outline-none ${
            errors.CPR
              ? "border-red-500 focus:ring"
              : "focus:ring focus:ring-blue-300"
          }`}
        />
        {errors.CPR && (
          <p className="text-red-500 text-sm mt-1 text-left">{errors.CPR}</p>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
        <div>
          <label className="block text-sm text-gray-500 mb-1 text-left">
            {translate("First Name", "الاسم الأول")}
          </label>
          <input
            type="text"
            name="Fname"
            placeholder=""
            value={formData.Fname}
            onChange={handleChange}
            className={`w-full border rounded-md px-3 py-2 focus:outline-none ${
              errors.Fname
                ? "border-red-500 focus:ring"
                : "focus:ring focus:ring-blue-300"
            }`}
          />
          {errors.Fname && (
            <p className="text-red-500 text-sm mt-1 text-left">
              {errors.Fname}
            </p>
          )}
        </div>
        <div>
          <label className="block text-sm text-gray-500 mb-1 text-left">
            {translate("Last Name", "الاسم الأخير")}
          </label>
          <input
            type="text"
            placeholder=""
            name="Lname"
            value={formData.Lname}
            onChange={handleChange}
            className={`w-full border rounded-md px-3 py-2 focus:outline-none ${
              errors.Lname
                ? "border-red-500 focus:ring"
                : "focus:ring focus:ring-blue-300"
            }`}
          />
          {errors.Lname && (
            <p className="text-red-500 text-sm mt-1 text-left">
              {errors.Lname}
            </p>
          )}
        </div>
      </div>

      {/* Mobile Number */}
      <div>
        <label className="block text-sm text-gray-500 mb-1 text-left">
          {translate("Mobile Number", "رقم الهاتف المحمول")}
        </label>
        <div className="flex items-center border rounded-md px-3 py-2">
          <div className="flex items-center space-x-2 pr-2 border-r">
            <img
              src="https://flagcdn.com/w40/bh.png"
              alt="Bahrain flag"
              className="w-5 h-4"
            />
            <span className="text-sm">+973</span>
          </div>
          <input
            type="text"
            placeholder=""
            name="PhoneNumber"
            className={`ml-3 w-full focus:outline-none`}
            value={formData.PhoneNumber}
            onChange={handleChange}
          />
        </div>
        {errors.PhoneNumber && (
          <p className="text-red-500 text-sm mt-1 text-left">
            {errors.PhoneNumber}
          </p>
        )}
      </div>

      {/* Email Address */}
      <div>
        <label className="block text-sm text-gray-500 mb-1 text-left">
          {translate("Email Address", "عنوان البريد الإلكتروني")}
        </label>
        <input
          type="email"
          placeholder=""
          name="Email"
          value={formData.Email}
          onChange={handleChange}
          className={`w-full border rounded-md px-3 py-2 focus:outline-none ${
            errors.Email
              ? "border-red-500 focus:ring"
              : "focus:ring focus:ring-blue-300"
          }`}
        />
        {errors.Email && (
          <p className="text-red-500 text-sm mt-1 text-left">{errors.Email}</p>
        )}
      </div>
    </div>
  );
};

const UserDriverForm = ({ formData, handleChange, translate, errors }) => {
  return (
    <div className="max-w-lg mx-auto space-y-6 bg-white pt-4">
      {/* Mobile Number */}
      <div>
        <label className="block text-sm text-gray-500 mb-1 text-left">
          {translate("Mobile Number", "رقم الهاتف المحمول")}
        </label>
        <div className="flex items-center border rounded-md px-3 py-2">
          <div className="flex items-center space-x-2 pr-2 border-r">
            <img
              src="https://flagcdn.com/w40/bh.png"
              alt="Bahrain flag"
              className="w-5 h-4"
            />
            <span className="text-sm">+973</span>
          </div>
          <input
            type="text"
            placeholder=""
            name="PhoneNumber"
            value={formData.PhoneNumber}
            onChange={handleChange}
            className="ml-3 w-full focus:outline-none"
          />
        </div>
        {errors.PhoneNumber && (
          <p className="text-red-500 text-sm mt-1 text-left">
            {errors.PhoneNumber}
          </p>
        )}
      </div>
    </div>
  );
};

const Activation = () => {
  const [step, setStep] = useState(1);
  const [finalForm, setFinalForm] = useState({});
  const [loading, setLoading] = useState(false);
  const profileData = useSelector(selectProfileData);
  const [formData, setFormData] = useState({
    CPR: "",
    Fname: "",
    Lname: "",
    PhoneNumber: "",
    Email: "",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const policyNum = searchParams.get("policy");
  const [selected, setSelected] = useState("me");
  // const [mobile, setMobile] = useState("");
  const translate = useLanguageTranslate();
  const [errors, setErrors] = useState({});
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [savedPinId, setPinId] = useState("");

  const handleOTPChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);

    // Focus next input if value is entered
    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const resetForm = () => {
    console.log(profileData?.FirstName);
    setFormData({
      CPR: "",
      Fname: "",
      Lname: "",
      PhoneNumber: "",
      Email: "",
    });
    setErrors({});
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.CPR || formData.CPR.length !== 9) {
      newErrors.CPR = "CPR must be 9 digits.";
    }
    if (!formData.Fname.trim()) {
      newErrors.Fname = "First name is required.";
    }
    if (!formData.Lname.trim()) {
      newErrors.Lname = "Last name is required.";
    }
    if (!formData.PhoneNumber || formData.PhoneNumber.length !== 8) {
      newErrors.PhoneNumber = "Mobile must be 8 digits.";
    }
    if (
      !formData.Email ||
      !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.Email)
    ) {
      newErrors.Email = "Enter a valid email address.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const Submit = async () => {
    if (selected == "someone") {
      if (validate()) {
        // proceed with submit logic
        if (step === 1) {
          setLoading(true);
          var pinId = await sendToken(formData.PhoneNumber);
          if (
            pinId?.requestError?.serviceException?.messageId ==
            "THROTTLE_EXCEPTION"
          ) {
            setLoading(false);
            toast.error("Too many requests per destination. Try again later.");
          } else {
            setLoading(false);
            setPinId(pinId);
            setStep(2);
          }
        } else {
          if (step === 2) {
            try {
              const otpValue = otp.join(""); // turns ["1", "2", "3", "4"] into "1234"
              setLoading(true);
              var isVerified = await verifytoken(savedPinId.pinId, otpValue);

              if (
                isVerified?.verified == true &&
                isVerified?.pinError == undefined
              ) {
                const updatedFormData = {
                  ...formData,
                  PhoneNumber: `+973${formData.PhoneNumber}`,
                };
                const planPayload = {
                  PolicyNumber: policyNum,
                  driver: updatedFormData,
                  PlateType: "PVT",
                };
                setFinalForm(planPayload);
                var result = await CreateOrUpdatePlan({ Data: planPayload });
                if (
                  result.statusCode == 200 &&
                  result.msg == "Plan created or updated"
                ) {
                  setLoading(false);
                  navigate("/motor-insurance/sbdrive-activated");
                } else {
                  toast.error(result.Message);
                }
              } else if (
                isVerified?.verified == true &&
                isVerified?.pinError == "TTL_EXPIRED"
              ) {
                setLoading(false);
                toast.error("OTP expired");
              }
            } catch (error) {
              setLoading(false);
              toast.error("Something went wrong during OTP verification");
            }

            // else if(){

            // }
          }
        }

        console.log("Submit", formData);
      }
    } else {
      if (formData.PhoneNumber.length === 8) {
        if (step === 1) {
          //   setFormData(prev => ({
          //     ...prev,
          //     CPR: "84010112345",
          //     firstName: "Ali",
          //     lastName: "Mohammed",
          //     email: "ali@example.com",
          //  }));
          setLoading(true);
          var pinId = await sendToken(formData.PhoneNumber);
          if (
            pinId?.requestError?.serviceException?.messageId ==
            "THROTTLE_EXCEPTION"
          ) {
            setLoading(false);
            toast.error("Too many requests per destination. Try again later.");
          } else {
            setLoading(false);
            setPinId(pinId);
            setStep(2);
          }
        } else {
          if (step === 2) {
            try {
              const otpValue = otp.join(""); // turns ["1", "2", "3", "4"] into "1234"
              setLoading(true);
              var isVerified = await verifytoken(savedPinId.pinId, otpValue);
              if (
                isVerified?.verified == true &&
                isVerified?.pinError == undefined
              ) {
                const updatedFormData = {
                  ...formData,
                  PhoneNumber: `+973${formData.PhoneNumber}`,
                  CPR: profileData.CPR,
                  Fname: profileData.FirstName,
                  Lname: profileData.LastName,
                  Email: profileData.Email,
                };
                const planPayload = {
                  PolicyNumber: policyNum,
                  driver: updatedFormData,
                  PlateType: "PVT",
                };
                var result = await CreateOrUpdatePlan({
                  Data: planPayload,
                });
                if (
                  result.statusCode == 200 &&
                  result.msg == "Plan created or updated"
                ) {
                  setLoading(false);
                  navigate("/motor-insurance/sbdrive-activated");
                } else {
                  toast.error(result.Message);
                }
              } else if (
                isVerified?.verified == true &&
                isVerified?.pinError == "TTL_EXPIRED"
              ) {
                setLoading(false);
                toast.error("OTP expired");
              } else {
                setLoading(false);
                toast.error("Something went wrong during OTP verification");
              }
            } catch (error) {
              setLoading(false);
              toast.error("Something went wrong during OTP verification");
            }
          }
        }
      }
    }
  };
  const handleClose = () => {
    if (step === 2) {
      setOtp(["", "", "", ""]);
      setStep(1);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="mainCarDetailsModal pt-[80px] pb-[5%] max767:w-full max767:overflow-y-scroll max767:pb-[30%] max767:h-screen ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll max767:pt-[0]">
      <button
        type="button"
        onClick={handleClose}
        aria-label={translate(step === 2 ? "Back" : "Close", step === 2 ? "رجوع" : "إغلاق")}
        className="fixed top-4 right-4 rtl:right-auto rtl:left-4 z-50 flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
        >
          <img src={closeIcon} alt="Close" className="w-5 h-5" />
      </button>
      <RenewMotorLayout
        is_hide_back_btn={true}
        btn_disabled={
          (step === 1 &&
            (selected === "me"
              ? !formData.PhoneNumber || formData.PhoneNumber.length !== 8
              : Object.values(formData).some(
                  (value) => value.trim() === ""
                ))) ||
          (step === 2 &&
            (otp.some((d) => d.trim() === "") || otp.join("").length !== 4)) ||
          loading
        }
        btn_onClick={Submit}
      >
        <div className={`${loading ? "" : "hidden"}`}>
          <Loader />
        </div>

        <div
          className={`mainCarDetailsModal pt-[80px] pb-[5%] max767:w-full max767:overflow-y-scroll max767:pb-[30%] max767:h-screen ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll max767:pt-20 ${
            step === 1 && !loading ? "" : "hidden"
          }`}
        >
          <div className="changeplatenumber w-[500px] max-w-[100%] mx-auto bg-white max767:p-5 text-center">
            <p className="text-2xl font-bold pb-2">
              {translate(
                "Activate Solidarity Drive Program",
                "تفعيل برنامج سوليداريتي درايف"
              )}
            </p>
            <p className="text-left">
              {translate(
                "Drive safe. Earn points. Get rewarded. Activate your Drive Program and start earning points you can redeem for exciting perks.",
                "حول قيادتك الآمنة إلى مكافآت حقيقية! فعّل البرنامج وابدأ في جمع النقاط واستبدالها بمكافآت مميزة."
              )}
            </p>
            <br />
            <p className="text-left font-semibold">
              {translate("Who's driving this car? ", "من يقود السيارة؟")}
            </p>
            <p className="text-left">
              {translate(
                "You can activate the program for yourself or for someone else who regularly drives this vehicle.",
                "تقدر تفعّل البرنامج لنفسك أو لشخص ثاني يستخدم السيارة بشكل دائم."
              )}
            </p>
            <br />
            <div className="inline-flex rounded-md  border overflow-hidden w-full">
              <button
                onClick={() => {
                  if (selected !== "me") {
                    resetForm(); // <-- clear the form here
                  }
                  setSelected("me");
                }}
                className={`px-4 py-2 text-sm font-medium w-[50%] ${
                  selected === "me"
                    ? "bg-blue-50 text-sky-500 border border-sky-500 rounded-l-md "
                    : "bg-white text-gray-700"
                }`}
              >
                {translate("I am the driver", "أنا السائق")}
              </button>
              <button
                onClick={() => {
                  if (selected !== "someone") {
                    resetForm(); // <-- clear the form here
                  }

                  setSelected("someone");
                }}
                className={`px-4 py-2 text-sm font-medium w-[50%] ${
                  selected === "someone"
                    ? "bg-blue-50 text-sky-500 border border-sky-500 rounded-r-md "
                    : "bg-white text-gray-700"
                }`}
              >
                {translate("Activate for someone else", "تفعيل لشخص آخر")}
              </button>
            </div>
            <div>
              <div className={selected === "someone" ? "block" : "hidden"}>
                <UserNotDriverForm
                  formData={formData}
                  handleChange={handleChange}
                  translate={translate}
                  errors={errors}
                />
              </div>
              <div className={selected !== "someone" ? "block" : "hidden"}>
                <UserDriverForm
                  formData={formData}
                  handleChange={handleChange}
                  translate={translate}
                  errors={errors}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className={`mainCarDetailsModal pt-[80px] pb-[5%] max767:w-full max767:overflow-y-scroll max767:pb-[30%] max767:h-screen ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll max767:pt-20 ${
            step === 2 && !loading ? "" : "hidden"
          }`}
        >
          <div className="flex flex-col items-center justify-center   px-4">
            <div className="   w-full max-w-md text-center">
              <h2 className="text-2xl font-semibold text-gray-800 mb-2">
                {translate("Verify OTP", "تحقق من رمز التحقق")}
              </h2>
              <p className="text-sm text-gray-600 mb-4">
                {translate(
                  "Enter the 4-digit code number that has been sent to your mobile number",
                  "أدخل رمز التحقق المكون من 4 أرقام الذي تم إرساله إلى رقم هاتفك المحمول"
                )}
              </p>
              <p className="text-sm text-gray-700 mb-6">
                {translate("We sent it to", "تم إرساله إلى")}{" "}
                <span className="font-semibold">
                  +973 {formData.PhoneNumber}.
                </span>{" "}
                <button
                  type="button"
                  onClick={() => { setOtp(["", "", "", ""]); setStep(1); }}
                  className="text-blue-600 hover:underline ml-1"
                >
                  {translate("Change", "تغيير")}
                </button>
              </p>

              <div className="flex justify-center gap-4 mb-6">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleOTPChange(e.target.value, index)}
                    className="w-14 h-14 text-2xl text-center border rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                ))}
              </div>

              <button
                type="button"
                onClick={async () => {
                  setLoading(true);
                  const newPinId = await sendToken(formData.PhoneNumber);
                  setLoading(false);
                  if (newPinId?.requestError?.serviceException?.messageId == "THROTTLE_EXCEPTION") {
                    toast.error("Too many requests per destination. Try again later.");
                  } else {
                    setPinId(newPinId);
                    setOtp(["", "", "", ""]);
                    toast.success(translate("A new code has been sent", "تم إرسال رمز جديد"));
                  }
                }}
                className="text-sm text-blue-700 hover:underline"
              >
                {translate("I didn't receive a code", "لم أستلم الرمز")}
              </button>
            </div>
          </div>
        </div>
      </RenewMotorLayout>
    </div>
  );
};

export default Activation;
